import React from 'react';
import PropTypes from 'prop-types';
import { calculateBillingDates } from '../../../utils';

/**
 * Reusable component for displaying billing details in pause scenarios
 * Standardizes the billing information text across different pause contexts
 */
const PauseBillingDetailsFooter = ({ className = '', pauseDays = 30 }) => {
  const { formattedNextBillingDateAfterPause } = calculateBillingDates();
  return (
    <div className={`billing-details text-muted small ${className}`}>
      <p>
        Pausing your billing means we’ve added {pauseDays} free days to your subscription. Your subscription will
        automatically renew at your normal rate on <strong>{formattedNextBillingDateAfterPause}</strong>. You can adjust
        or cancel anytime in your Member Center.
      </p>
    </div>
  );
};

PauseBillingDetailsFooter.propTypes = {
  className: PropTypes.string,
  pauseDays: PropTypes.number
};

export default PauseBillingDetailsFooter;
